import { UserRole } from "./useUserRole";

/**
 * Get the default route for a user based on their role.
 * All routes now use /flowgrid/ base path.
 */
export const getDefaultRouteForRole = (role: UserRole | null): string => {
  if (role === "end_user") {
    return "/flowgrid/self-service";
  }
  // Staff users go to flowgrid home
  return "/flowgrid/home";
};

/**
 * Route mapping for reference and backwards compatibility
 * Note: Legacy routes have been removed, this is kept for documentation
 */
export const ROUTE_MAP: Record<string, string> = {
  // XSM Module
  'dashboard': '/flowgrid/xsm/dashboard',
  'dashboard-builder': '/flowgrid/xsm/dashboard-builder',
  'incidents': '/flowgrid/xsm/incidents',
  'problems': '/flowgrid/xsm/problems',
  'sla': '/flowgrid/xsm/sla',
  'service-requests': '/flowgrid/xsm/service-requests',
  'cmdb': '/flowgrid/xsm/cmdb',
  'assets': '/flowgrid/xsm/assets',
  'catalog': '/flowgrid/xsm/catalog',
  'changes': '/flowgrid/xsm/changes',
  'analytics': '/flowgrid/xsm/analytics',
  'my-performance': '/flowgrid/xsm/my-performance',
  'reports': '/flowgrid/xsm/reports',
  'quality-assurance': '/flowgrid/xsm/quality-assurance',
  'major-incidents': '/flowgrid/xsm/major-incidents',
  'field-calendar': '/flowgrid/xsm/field-calendar',
  'workflows': '/flowgrid/xsm/workflows',
  'audit-logs': '/flowgrid/xsm/audit-logs',
  // Agent Console
  'agent-console': '/flowgrid/agent-console',
  // IAM Module
  'users': '/flowgrid/iam/users',
  'profile': '/flowgrid/iam/profile',
  'security': '/flowgrid/iam/security',
  'branding': '/flowgrid/iam/branding',
  'governance': '/flowgrid/iam/governance',
  'setup-2fa': '/flowgrid/iam/setup-2fa',
  // Global Settings Module
  'global-settings': '/flowgrid/global-settings',
  'system-settings': '/flowgrid/global-settings/system-settings',
  'email-domains': '/flowgrid/global-settings/email-domains',
  'version-history': '/flowgrid/global-settings/version-history',
  // Self-Service Module
  'self-service': '/flowgrid/self-service',
  'my-incidents': '/flowgrid/self-service/my-incidents',
  'my-service-requests': '/flowgrid/self-service/my-service-requests',
  'my-assets': '/flowgrid/self-service/my-assets',
  // Knowledge Module
  'knowledge': '/flowgrid/knowledge',
  // System Pages
  'verify': '/flowgrid/verify',
  'unauthorized': '/flowgrid/unauthorized',
  'not-found': '/flowgrid/not-found',
  // Home
  'home': '/flowgrid/home',
};

/**
 * Get route by key
 */
export const getRoute = (key: string): string => {
  return ROUTE_MAP[key] || `/flowgrid/${key}`;
};
